import React from "react";
import "./panel.css";

export default function Panel({ title, children, className = "", showSettings = false }) {
  return (
    <div className={`ms-panel ${className}`}>
      {title && (
        <div className="ms-panel-title">
          <span>{title}</span>
          {showSettings && <span className="ms-panel-settings">⚙</span>}
        </div>
      )}
      <div className="ms-panel-content">{children}</div>
    </div>
  );
}

